import React from 'react';
import styles from 'styles/components/BrandIcon.module.sass';
import { ReactComponent as VisaLogo } from 'assets/images/svg/visa-svgrepo-com.svg'
import { ReactComponent as MasterCardLogo } from 'assets/images/svg/mc_symbol.svg'

/**
 * BrandIcon component displays the appropriate brand logo based on the provided brand name.
 * 
 * @param {Object} props - The properties object.
 * @param {string} props.brand - The brand name (e.g., 'Visa', 'MasterCard', 'Amex', 'Discover').
 * @returns {JSX.Element} The rendered brand icon.
 */
const BrandIcon: React.FC<{ brand: string }> = ({ brand }) => {
  const brandLower = brand.toLowerCase();

  const getBrandSVG = () => {
    switch (brandLower) {
      case 'visa':
        return <VisaLogo aria-label='Visa Logo' />
      case 'mastercard':
        return <MasterCardLogo aria-label='MasterCard Logo' />
      case 'amex':
      case 'american express':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M6 8h4l1 2 1-2h4v8H6V8z" fill="white"/>
            <path d="M8 10h2v4H8v-4zM14 10h2v4h-2v-4z" fill="white"/>
          </svg>
        );
      case 'discover':
        return (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M4 8h16v8H4V8z" fill="white"/>
            <circle cx="16" cy="12" r="3" fill="transparent" stroke="white" strokeWidth="1"/>
          </svg>
        );
      default:
        return brand.charAt(0).toUpperCase();
    }
  };

  return (
    <div className={styles['brand-badge']}>
      {getBrandSVG()}
    </div>
  );
};

export default BrandIcon;